import React from 'react';
import { Eye, Edit, Trash2 } from 'lucide-react';
import { Card } from '../components/ui/Card';
import { useNavigate } from 'react-router-dom';
export function EmailDetails() {
  const navigate = useNavigate();
  const emails = [{
    id: 1,
    subject: 'Welcome to Desert Sage',
    body: 'Thank you for registering...',
    created: '2023-01-01',
    status: 'Active'
  }, {
    id: 2,
    subject: 'Course Completion',
    body: 'Congratulations on completing...',
    created: '2023-01-01',
    status: 'Active'
  }, {
    id: 3,
    subject: 'Password Reset',
    body: 'Click here to reset...',
    created: '2023-01-01',
    status: 'Inactive'
  }];
  return <div className="space-y-4" data-id="element-1005">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-1006">Email Details</h1>

      <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1007">
        <div className="overflow-x-auto" data-id="element-1008">
          <table className="w-full text-sm text-left" data-id="element-1009">
            <thead className="bg-slate-800 text-white font-medium" data-id="element-1010">
              <tr data-id="element-1011">
                <th className="px-3 py-3 border-r border-slate-700 text-center w-12" data-id="element-1012">
                  Id
                </th>
                <th className="px-3 py-3 border-r border-slate-700 w-40" data-id="element-1013">
                  Subject
                </th>
                <th className="px-3 py-3 border-r border-slate-700" data-id="element-1014">Body</th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-36" data-id="element-1015">
                  Created
                </th>
                <th className="px-3 py-3 border-r border-slate-700 text-center w-16" data-id="element-1016">
                  Status
                </th>
                <th className="px-3 py-3 text-center w-32" data-id="element-1017">
                  <div data-id="element-1018">Actions</div>
                  <div className="text-xs font-normal text-slate-400 mt-1" data-id="element-1019">
                    View | Edit | Delete
                  </div>
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-200" data-id="element-1020">
              {emails.map(email => <tr key={email.id} className="hover:bg-slate-50" data-id="element-1021">
                  <td className="px-3 py-2.5 border-r border-slate-200 text-center align-top" data-id="element-1022">
                    {email.id}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 font-medium align-top" data-id="element-1023">
                    {email.subject}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 text-slate-600 align-top max-w-sm" data-id="element-1024">
                    <p className="line-clamp-3 text-xs" data-id="element-1025">{email.body}</p>
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 text-center align-top" data-id="element-1026">
                    {email.created}
                  </td>
                  <td className="px-3 py-2.5 border-r border-slate-200 text-center align-top" data-id="element-1027">
                    <input type="checkbox" defaultChecked={email.status === 'Active'} className="rounded border-slate-300" data-id="element-1028" />
                  </td>
                  <td className="px-3 py-2.5 text-center align-top" data-id="element-1029">
                    <div className="flex items-center justify-center gap-2" data-id="element-1030">
                      <button title="View" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/email-details/view/${email.id}`)} data-id="element-1031">
                        <Eye className="h-4 w-4" data-id="element-1032" />
                      </button>
                      <button title="Edit" className="p-1 text-slate-500 hover:text-blue-600" onClick={() => navigate(`/email-details/edit/${email.id}`)} data-id="element-1033">
                        <Edit className="h-4 w-4" data-id="element-1034" />
                      </button>
                      <button title="Delete" className="p-1 text-slate-500 hover:text-red-600" data-id="element-1035">
                        <Trash2 className="h-4 w-4" data-id="element-1036" />
                      </button>
                    </div>
                  </td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
}